import { DataList as ChakraDataList } from '@chakra-ui/react';
import * as React from 'react';
import { InfoTip } from './toggle-tip';

export const DataListRoot = ChakraDataList.Root;

interface ItemProps extends ChakraDataList.ItemProps {
  label: React.ReactNode;
  value: React.ReactNode;
  info?: React.ReactNode;
  grow?: boolean;
  labelColor?: string;
  labelFontSize?: string;
  labelFontWeight?: string;
  labelMinW?: string;
  labelIcon?: React.ElementType;
  itemValueProps?: ChakraDataList.ItemValueProps;
}

export const DataListItem = React.forwardRef<HTMLDivElement, ItemProps>(
  function DataListItem(props, ref) {
    const {
      label,
      info,
      value,
      children,
      grow,
      labelIcon,
      fontSize = '15px',
      labelFontSize = '15px',
      labelFontWeight = 'normal',
      labelColor = 'gray.600',
      labelMinW = '100px',
      itemValueProps,
      ...rest
    } = props;

    return (
      <ChakraDataList.Item ref={ref} {...rest}>
        <ChakraDataList.ItemLabel
          flex={grow ? '1' : undefined}
          fontWeight={labelFontWeight}
          fontSize={labelFontSize}
          color={labelColor}
          minW={labelMinW}
        >
          {labelIcon && React.createElement(labelIcon, { width: 16, height: 16, strokeWidth: 1.5 })}
          {label}
          {info && <InfoTip>{info}</InfoTip>}
        </ChakraDataList.ItemLabel>
        <ChakraDataList.ItemValue
          fontSize={fontSize}
          flex={grow ? '1' : undefined}
          {...itemValueProps}
        >
          {value}
        </ChakraDataList.ItemValue>

        {children}
      </ChakraDataList.Item>
    );
  }
);
